import { render } from "./SearchContainer.vue?vue&type=template&id=5cac60a5"
import script from "./SearchContainer.vue?vue&type=script&lang=js"
export * from "./SearchContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__